import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialTableDataState } from "./initializes";
import type { TableData } from "./types";

const tableDataSlice = createSlice({
  name: "TableData",
  initialState: initialTableDataState,
  reducers: {
    setRecordViewItem: (state: TableData, action: PayloadAction<object[]>) => {
      state.recordViewItem = action.payload;
    },
    setTotalHits: (state: TableData, action: PayloadAction<number>) => {
      state.totalHits = action.payload;
    },
  },
});

export const { setRecordViewItem, setTotalHits } = tableDataSlice.actions;

export default tableDataSlice.reducer;
